import {
  ArrowRightLeft, BookMarked, Copy, Database, FolderKanban, PanelsTopLeft, ScanSearch, ScrollText,
  Settings2, ShieldCheck, Terminal, Users,
} from 'lucide-react'

import type { Me } from '@/lib/auth'

export type NavItem = {
  to: string
  label: string
  icon: typeof Terminal
  /** shown only when the flag holds for the signed-in user */
  flag?: 'approvals' | 'owner'
}

export type NavGroup = { group: string; items: NavItem[] }

/** Menu by task. The command palette lists the same pages. */
export const NAV: NavGroup[] = [
  {
    group: 'Jira',
    items: [
      { to: '/operations', label: 'Operations', icon: Terminal },
      { to: '/users', label: 'Users', icon: Users },
      { to: '/projects', label: 'Projects', icon: FolderKanban },
      { to: '/field-copy', label: 'Field copy', icon: Copy, flag: 'owner' },
    ],
  },
  {
    group: 'Investigate',
    items: [
      { to: '/analysis/user', label: 'User usage', icon: ScanSearch },
      { to: '/audit', label: 'Audit', icon: ScrollText },
    ],
  },
  {
    group: 'Integrations',
    items: [
      { to: '/panels', label: 'Panels', icon: PanelsTopLeft },
      { to: '/tge', label: 'TGE → STAGIL', icon: ArrowRightLeft },
    ],
  },
  {
    group: 'Reference',
    items: [
      { to: '/reference', label: 'vulpio API', icon: BookMarked },
    ],
  },
  {
    group: 'System',
    items: [
      { to: '/settings/tokens', label: 'Settings', icon: Settings2 },
      { to: '/settings/cache', label: 'Jira cache', icon: Database },
      { to: '/approvals', label: 'Approvals', icon: ShieldCheck, flag: 'approvals' },
    ],
  },
]

export function visibleItems(items: NavItem[], me: Me): NavItem[] {
  return items.filter(
    (l) => (l.flag !== 'approvals' || me.approvals_enabled) && (l.flag !== 'owner' || me.role === 'owner'),
  )
}
